import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { CepDateValidationError, InvalidTacticField } from './TacticFieldsValidation.hook';
import TacticFieldsValidationDialogConfig from './TacticFieldsValidationDialog.config';
import {
  dialogStyle,
  titleStyle,
  dialogContentStyle,
  dialogContentBoxStyle,
  listIconStyle,
} from './TacticFieldsValidationDialog.style';
import { mayaCepEditRoute } from 'basics/constants/routes.constants';
import ActionButton from 'components/ActionButton';
import Box from 'yoda-ui/components/Box';
import Dialog from 'yoda-ui/components/Dialogs/Dialog';
import DialogActions from 'yoda-ui/components/Dialogs/Dialog/DialogActions/DialogActions';
import DialogContent from 'yoda-ui/components/Dialogs/Dialog/DialogContent';
import Icon, { Icons } from 'yoda-ui/components/Icons/Icon';

type TacticFieldsValidationDialogTypes = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  invalidTactics: InvalidTacticField[];
  cepDateError?: CepDateValidationError | null;
  validationError?: boolean;
  cepId?: string;
};

const TacticFieldsValidationDialog: FC<TacticFieldsValidationDialogTypes> = ({
  open,
  setOpen,
  invalidTactics,
  cepDateError,
  validationError,
  cepId,
}) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  const handleGoToEdit = () => {
    window.location.href = `${mayaCepEditRoute}?id=${cepId}&step=2`;
  };

  const { actionsButtonConfig, fieldLabelMap } = TacticFieldsValidationDialogConfig(
    handleClose,
    handleGoToEdit,
  );

  return (
    <Dialog open={ open } sx={ dialogStyle }>
      <Box sx={ titleStyle }>{ t('maya_tactic_fields_validation_dialog_title') }</Box>
      <DialogContent sx={ dialogContentStyle }>
        {
          validationError && (
            <Box sx={ dialogContentBoxStyle }>
              <Box>
                <Icon sx={ listIconStyle } name={ Icons.fiberManualRecordRounded }></Icon>
                { t('maya_tactic_fields_validation_fetch_error') }
              </Box>
            </Box>
          )
        }
        {
          cepDateError && (
            <Box sx={ dialogContentBoxStyle }>
              <Box>
                <Icon sx={ listIconStyle } name={ Icons.fiberManualRecordRounded }></Icon>
                { t('maya_tactic_fields_validation_cep_date_range') }
              </Box>
            </Box>
          )
        }
        {
          invalidTactics.map((item) => (
            <Box
              key={ item.tactic._id }
              sx={ dialogContentBoxStyle }
            >
              <Box>
                <Box>{ item.tactic.title }</Box>
                {
                  item.validationIssues.map((field) => (
                    <Box key={ field }>
                      <Icon sx={ listIconStyle } name={ Icons.fiberManualRecordRounded }></Icon>
                      { fieldLabelMap[field] || field }
                    </Box>
                  ))
                }
              </Box>
            </Box>
          ))
        }
      </DialogContent>

      <DialogActions>
        <ActionButton { ...actionsButtonConfig.cancelButtonConfig } />
        <ActionButton { ...actionsButtonConfig.submitButtonConfig }/>
      </DialogActions>
    </Dialog>
  );
};

export default TacticFieldsValidationDialog;
